var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TermDefinition } from '../TermDefinition/TermDefinition.old';
import styles from './styles.module.styl';
export var LetterSection = function (_a) {
    var letter = _a.letter, terms = _a.terms;
    return (React.createElement("section", null,
        React.createElement("h2", { id: letter, className: styles.letterHeader }, letter),
        React.createElement("ul", { className: styles.terms }, terms.map(function (term) { return (React.createElement(TermDefinition, __assign({}, term))); }))));
};
